<template>
    <Overlay v-if="currentRouteName != 'ResetPassword'" />
    <LoginModal v-if="currentRouteName && currentRouteName != 'ResetPassword'" />
    <Header v-if="currentRouteName && currentRouteName != 'ResetPassword'" />
    <div class="container-fluid">
        <div class="row">
            <router-view name="c" />
            <router-view name="a" />
            <!-- <router-view v-slot="{ Component }">
                <transition>
                    <component :is="Component" />
                </transition>
            </router-view> -->
        </div>
    </div>
    <!-- <FreeScoutChatbot /> -->
</template>

<script>
import Header from "@/components/Header";
// import FreeScoutChatbot from '@/components/FreeScoutChatbot'
import LoginModal from "@/components/modals/LoginModal";
import Overlay from "@/components/overlay/Overlay";
import cms6Mixin from "@/mixins/cms6Mixin";
import siteMixin from "@/mixins/siteMixin";
export default {
    name: "App",
    components: {
        Header,
        LoginModal,
        Overlay,
        // FreeScoutChatbot,
    },
    mixins: [cms6Mixin, siteMixin],
    mounted() {
        this.syncDashboardFeatureFlags();
    },
    computed: {
        currentRouteName() {
            return this.$router.currentRoute.value.name;
        },
    },
    methods: {
        async syncDashboardFeatureFlags() {
            if (this.getSiteType() !== "cms6") {
                return;
            }

            const site = this.getSite();
            if (!site?.id) {
                return;
            }

            try {
                const response = await this.getClientOptionKey("business_directory_enabled", "dashboard-feature-flags");
                const isEnabled = response?.data === true || response?.data === 1 || response?.data === "1";
                localStorage.setObject("site", { ...site, supportsBusinessDirectory: isEnabled });
                window.dispatchEvent(new CustomEvent("site-updated"));

                if (!isEnabled && this.currentRouteName === "BusinessDirectories") {
                    this.$router.replace("/");
                }
            } catch (error) {
                localStorage.setObject("site", { ...site, supportsBusinessDirectory: false });
                window.dispatchEvent(new CustomEvent("site-updated"));
            }
        },
    },
};
</script>
